import { Image } from "@kobalte/core";
import { styled } from "solid-styled-components";

export const FlagIcon = styled(Image.Root)<{ selected: boolean }>`
  width: 60px;
  aspect-ratio: 16 / 9;
  cursor: pointer;
  ${({ theme, selected }) => (selected ? `box-shadow: ${theme?.tracklist.activeShadow};` : "")}
  & > * {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
